import {TabStatus} from '../../../../../../../shared/tabs/tab-status.model';

export const TAB_STATUS_IN_PROGRESS: TabStatus = {
  totalSections: 2,
  completedSections: 1,
};
export const TAB_STATUS_COMPLETED: TabStatus = {
  totalSections: 2,
  completedSections: 2,
};
